
import Main from "@/views/Main.vue";
const customerRoutes = [
  {
    path: "/buyershop",
    icon: "key",
    title: "买手店管理",
    name: "buyershop",
    component: Main,
    children: [
      {
        path: "shoppe",
        title: "专柜Stock Location",
        name: "shoppe",
        component: resolve => {
          require(["@/views/buyershop/shoppe.vue"], resolve);
        }
      },
      {
        path: "shoppe/level",
        title: "专柜买手等级管理",
        name: "shoppeLevel",
        component: resolve => {
          require(["@/views/buyershop/shoppe-level.vue"], resolve);
        }
      },
      {
        path: "docking",
        title: "对接系统管理",
        name: "docking",
        component: resolve => {
          require(["@/views/buyershop/cn/docking.vue"], resolve);
        }
      },
      {
        path: "task",
        title: "买手店更新任务管理",
        name: "ConfigTask",
        component: resolve => {
          require(["@/views/buyershop/task.vue"], resolve);
        }
      },
      {
        path: "exemption",
        title: "免检标识配置",
        name: "dockingAuth",
        component: resolve => {
          require(["@/views/buyershop/exemption.vue"], resolve);
        }
      },
      {
        path: "dockingAuth/:id",
        title: "对接系统接口权限管理",
        name: "dockingAuth",
        component: resolve => {
          require(["@/views/buyershop/docking-auth.vue"], resolve);
        }
      },
      {
        path: "blacklist/aftersale",
        title: "售后店铺白名单配置",
        name: "AfterSaleBlackList",
        component: resolve => {
          require(["@/views/buyershop/vendorAfterSale.vue"], resolve);
        }
      },
      {
        path: "relation",
        title: "同源店铺配置",
        name: "BuyerShopRelation",
        component: resolve => {
          require(["@/views/buyershop/relationNew.vue"], resolve);
        }
      },
      {
        path: "pool/config",
        title: "商品池配置",
        name: "BuyerShopPoolConfig",
        component: resolve => {
          require(["@/views/buyershop/poolConfig.vue"], resolve);
        }
      },

      // ── CN 路由 ──
      {
        path: "cn/task",
        title: "买手店更新任务管理(CN)",
        name: "ConfigTaskCn",
        component: resolve => {
          require(["@/views/buyershop/cn/task.vue"], resolve);
        }
      },
      {
        path: "cn/shoppe/level",
        title: "专柜买手等级管理(CN)",
        name: "shoppeLevelCn",
        component: resolve => {
          require(["@/views/buyershop/cn/shoppe-level.vue"], resolve);
        }
      },
      {
        path: "cn/exemption",
        title: "免检标识配置(CN)",
        name: "dockingAuthCn",
        component: resolve => {
          require(["@/views/buyershop/cn/exemption.vue"], resolve);
        }
      },
      {
        path: "cn/relation",
        title: "同源店铺配置(CN)",
        name: "BuyerShopRelationCn",
        component: resolve => {
          require(["@/views/buyershop/cn/relationNew.vue"], resolve);
        }
      },
      {
        path: "cn/blacklist/aftersale",
        title: "售后店铺白名单配置(CN)",
        name: "AfterSaleBlackListCn",
        component: resolve => {
          require(["@/views/buyershop/cn/vendorAfterSale.vue"], resolve);
        }
      },
    ]
  },
]

export default customerRoutes
